import axios from "axios";
import classNames from "classnames";
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import "./App.css";
import {
  BaseData,
  BaseShelf,
  Channel,
  Content,
  EPGS,
  LikesData,
} from "./globalType";

import { Header } from "./components/header";
import { Footer } from "./components/footer";
import {
  displayDuration,
  displayNumber,
  getContentUrl,
  getHost,
  translate,
} from "./utils";
import { Popup } from "./components/popup";
import { AuthContext, UserContextType } from "./auth";
import { DateTime } from "luxon";
import { CategoryTopMenu, TopMenu } from "./components/topMenu";
import { TailSpin } from "react-loader-spinner";

declare var $: any;

interface MainProps {
  goToPage: (page: string, content: Content | null) => void;
  shelfSlug: string;
}

function Category(props: MainProps) {
  const authContext = useContext(AuthContext);

  const { goToPage, shelfSlug } = props;
  const [popup, setPopup] = useState<Content | null>(null);
  const [likesData, setLikesData] = useState<LikesData | null>(null)
  const [baseShelf, setBaseShelf] = useState<BaseData | null>(null)
  const [currentSlug, setCurrentSlug] = useState<string | undefined>(undefined);

  if (currentSlug !== shelfSlug) {
    setCurrentSlug(shelfSlug)
    setBaseShelf(null)
  }

  useEffect(() => {
    if (currentSlug) {
      fetchBaseData(currentSlug);
    }
  }, [currentSlug]);



  useEffect(() => {
    if (baseShelf && baseShelf.shelfs.length > 0) {
      const w_device = $(window).width();
      $('.main-slide').slick({
        infinite: true,
        dots: true,
        speed: 500,
        fade: true,
        cssEase: "linear",
        arrows: false,
      });

      $('.demo').slick({
        infinite: true,
        slidesToShow: w_device > 1200 ? 7 : w_device > 869 ? 5 : 2,
        slidesToScroll: w_device > 1200 ? 7 : w_device > 869 ? 5 : 2,

        arrows: w_device > 1200 ? true : false,

        prevArrow:
          '<img src="/ondemand/static/img/arr_left.png" class="arr-left">',
        nextArrow:
          '<button type="button" data-role="none" class="slick-next"><img src="/ondemand/static/img/arr_right.png" class="arr-right"></button>',
      });
    }
  }, [baseShelf])


  const fetchBaseData = async (slug: string) => {
    try {
      const result = await fetchBaseShelf(slug);
      setBaseShelf(result.data)
      
    } catch (error) {
      console.log(error);
    }
  };

  const likes = async (contentId:string | undefined) => {
    if (!contentId) return;
    if (likesData && likesData[contentId]) {
      setLikesData({
        ...likesData,
        [contentId]: false,
      })
      return;
    }
    const result = await likeContent(contentId, authContext?.user?.profile.access_token)
    if (!result) return;

    setLikesData({
      ...likesData,
      [contentId]: true,
    })
  }

  const now = DateTime.now();
  return (
    <>
      {!baseShelf && (
        <div className="d-flex justify-content-center align-items-center" style={{height: '100vh'}}>
        <TailSpin color="#00BFFF" height={150} width={150} />
        </div>
      )}
      <CategoryTopMenu goToPage={goToPage} page={currentSlug ? currentSlug: 'foryou'} menu={baseShelf?.menu ? baseShelf.menu: []} />
      {baseShelf && baseShelf.shelfs.map((shelf, shelfIndex) => {
        if (shelf.setting.type === 'by_banner') {
          return (
            <div key={shelf.id} className="main-BG w-100">
              <div className="main-slide">
                {shelf.shelf_items.map((b) => {
                  return <MainSlide content={b} key={b.id} goToPage={goToPage} likes={likes} likesData={likesData} menu={baseShelf.menu} />;
                })}
              </div>
            </div>
          )
        } else if (shelf.setting.type === 'by_shelfid' && shelf.shelf_items.length > 0) {
          let style = {}
          if (shelfIndex === 0) {
            style = {marginTop: '48px'}
          }
          
          return (
            <div key={shelf.id} className="container H-container sub-shelf" style={style}>
              <div className="mt-4 title-BG">
                <span className="title">
                  {translate(shelf.setting.title_th, shelf.setting.title_en, authContext?.lang)}
                </span>
                <span
                  className="pink-txt pointer"
                  onClick={() => {goToPage(`/ondemand/home/${shelf.id}`, null)}}
                >
                  See More
                  <img src="/ondemand/static/img/double-right.png" alt="" />
                </span>
              </div>
              <div className="slider demo NewRelease-BG">
                {shelf.shelf_items.map((item, index) => (
                  <CarouselItem
                    goToPage={goToPage}
                    key={item.id}
                    content={item}
                    setPopup={setPopup}
                    viewType="poster"
                    index={index}
                  />
                ))}
              </div>
            </div>
          )
        }
        return <div key={shelf.id}></div>
      })}

      <Popup popup={popup} goToPage={goToPage} likes={likes} likesData={likesData} />
    </>
  );
}

interface CarouselItemProps {
  content: Content;
  setPopup: React.Dispatch<React.SetStateAction<Content | null>>;
  viewType: string;
  index: number;
  goToPage: (page: string, content: Content | null) => void;
}
export function CarouselItem(props: CarouselItemProps) {
  const { content, setPopup, viewType, index, goToPage } = props;
  const handlePopupChange = useCallback(() => {
    setPopup(content);
  }, [content, setPopup]);

  const w_device = $(window).width();

  const handleImageMouseEnter = useMemo(
    () => (evt: React.MouseEvent) => {
      handlePopupChange();

      let w = $(evt.target).width();
      let h = $(evt.target).height();
      let pos = $(evt.target).offset();
      let l = pos.left + w / 2 < 160 ? 160 : pos.left + w / 2;
      let per_min = (pos.left / w_device) * 100;
      let per_max = (l / w_device) * 100;

      if (per_max > 20 && per_min < 12) l = "220px";

      if ($(evt.target).attr("landscape")) {
        if (per_max > 70) {
          l = "81vw";
        }
      }

      $(".popupVideo").css({
        top: pos.top + h / 2,
        left: l,
      });

      $(".popupVideo>.detail").css({
        width: `${w * 1.1 > 360 ? w * 1.1 : 360}px`,

        height: `${h * 1.1 > 380 ? w * 1.1 : 380}px`,
      });

      if (per_max < 20 && per_min < 12) {
        $(".popupVideo").css({
          top: pos.top + h / 2,
          left: 360 / 2 + w_device * 0.04,
          right: "auto",
          width: `${w * 1.1 > 360 ? w * 1.1 : 360}px`,
          height: `auto`,
        });

        $(".popupVideo>.detail").fadeIn("100");
      } else if (per_max > 85) {
        $(".popupVideo").css({
          top: pos.top + h / 2,
          left: w_device - 360 / 2 - w_device * 0.04,
          width: `${w * 1.1 > 360 ? w * 1.1 : 360}px`,
          height: `auto`,
        });
        $(".popupVideo>.detail").fadeIn("100");
      } else {
        $(".popupVideo>.detail").hide();
        $(".popupVideo>.detail").fadeIn("100");
      }
    },
    [handlePopupChange, viewType, w_device]
  );

  let handleMouseEnter: any = () => {};
  if (w_device >= 1200) {
    handleMouseEnter = handleImageMouseEnter;
  }

  let imgSrc = content.thumb_list ? content.thumb_list?.poster: '/ondemand/static/img/default_poster.jpg'

  return (
    <div id={content.id} className="pointer slide-item">
      <div className="p-3">
        <img
          onClick={() => {
            goToPage(`/ondemand/detail/${content.id}`, content);
          }}
          src={imgSrc}
          alt=""
          onMouseEnter={handleMouseEnter}
        />
      </div>
    </div>
  );
}

interface CarouselChannelProps {
  content: Channel;
  setPopup: React.Dispatch<React.SetStateAction<any | null>>;
  viewType: string;
  index: number;
  epgs: EPGS | null | undefined;
}
export function CarouselChannel(props: CarouselChannelProps) {
  const { content } = props;
  const style = {
    width: "100%",
    display: "block",
    backgroundColor: "#000",
  };
  return (
    <div className="pointer slide-item">
      <div className="p-2 slide-inner">
        <picture style={style}>
          <img src={content.payload.thumb} alt="slideImg" />
        </picture>
        <div className="sub-BG">
          <div className="box">True visions</div>
          <p>{content.title}</p>
        </div>
      </div>
    </div>
  );
}

interface MainSlideProps {
  content: Content;
  goToPage: (page: string, content: Content | null) => void;
  likes: (contentId: string) => void;
  likesData: LikesData | null;
  menu: BaseShelf[];
}
function MainSlide(props: MainSlideProps) {
  const { content, goToPage, likes, likesData, menu } = props;
  const w_device = $(window).width();
  let bgImg = content.thumb_list.landscape_image;
  if (w_device < 1200) {
    bgImg = content.thumb_list.square_image;
  }
  if (w_device < 600) {
    bgImg = content.thumb_list.portrait_image;
  }
  const style = {
    backgroundImage: `url('${bgImg}')`,
    backgroundPosition: 'center',
  };

  let likeCls = ''
  if (likesData && content) {
    likeCls = classNames({'active': likesData[content.id]})
  }

  return (
    <div className="banner-BG" style={style}>
      <div className="g-BG"></div>
      <div className="container H-container">
        <div className="inner">
          <div className="body-detail">
            <div className="type-BG">{content.genres?.join(",")}</div>
            <div className="rating">
              <img src="/ondemand/static/img/start.png" alt="" />
              <img src="/ondemand/static/img/start.png" alt="" />
              <img src="/ondemand/static/img/start.png" alt="" />
              <img src="/ondemand/static/img/start.png" alt="" />
              <img src="/ondemand/static/img/start.png" alt="" />
            </div>
            <div className="detail">
              <h1>{content.title}</h1>
              <p className="mt-4 inline-p">
                <img
                  src="/ondemand/static/img/d-video.png"
                  alt=""
                  className="mr-2"
                />
                {displayDuration(content.duration)}
                <img
                  src="/ondemand/static/img/d-play.png"
                  alt=""
                  className="ml-3 mr-2"
                />
                {displayNumber(content.count_views)}
                <img
                  src="/ondemand/static/img/d-like.png"
                  alt=""
                  className="ml-3 mr-2"
                />
                {displayNumber(content.count_likes)}
                <span className="ml-3 pink-txt web mr-2">Audio : </span>
                <span className="web">{content.audio?.join(", ")}</span>
                <span className="ml-3 pink-txt web mr-2">Subtitle : </span>
                <span className="web">{content.subtitle?.join(", ")}</span>
              </p>
              <p className="web">{content.description}</p>
            </div>
            <div className="action-BG">
            <button
                onClick={() => {
                  window.location.href = getContentUrl(content);
                }}
              >
                <img
                  src="/ondemand/static/img/play-white-l.png"
                  alt=""
                  className="mr-3"
                />
                Watch now
              </button>
              <button
                onClick={() => {
                  goToPage(`/ondemand/detail/${content.id}`, content);
                }}
              >
                <img src="/ondemand/static/img/info-l.png" alt="" />
              </button>
              <button className={likeCls} onClick={() => {likes(content.id)}}>
                <img src="/ondemand/static/img/like-l.png" alt="" />
              </button>
              <button>
                <img src="/ondemand/static/img/share-l.png" alt="" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

async function fetchBaseShelf(shelfSlug: string) {
  const host = getHost();
  return axios.get(`${host}/api/series-main-shelf/${shelfSlug}`);
}

async function fetchMyshelf(
  auth: UserContextType | null,
  action_type: string,
  appid: string,
  content_type: string,
  view_type: string,
  content_provider: string
) {
  if (auth?.user?.id) {
    const host = getHost();
    return axios.get(
      `${host}/api/my-shelf/${auth.user?.profile.ssoid}/users/${auth.user.id}?action_type=${action_type}&appid=${appid}&content_type=${content_type}&view_type=${view_type}&content_provider=${content_provider}&access_token=${auth.user?.profile.access_token}`
    );
  }

  return null;
}

async function likeContent(
  contentId: string,
  access_token: string | undefined
) {
  if (!access_token) return null
  const host = getHost();
  return axios.get(
    `${host}/api/likes/${contentId}?access_token=${access_token}`
  );
}

export default Category;
